export const URL_PARAM_CUSTOMER_ID = 'cid'

export const URL_PARAM_COUNT_DATE_START = 'scountdate'
export const URL_PARAM_COUNT_DATE_END = 'ecountdate'
